import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WorkDayQueryQueryVariables = Types.Exact<{
  date: Types.Scalars['LocalDate'];
  userPrincipalName: Types.Scalars['String'];
}>;


export type WorkDayQueryQuery = { __typename?: 'QueryModel', timesheets?: { __typename?: 'TimesheetsQueryModel', workDay?: { __typename?: 'WorkDay', date: string, workDayId: string, editable: boolean, employee?: { __typename?: 'Employee', firstName: string, lastName: string, email: string, userPrincipalName: string, timeEntryMethod: string, isMobileEmployee: boolean } | null, timeEntries?: Array<{ __typename?: 'TimeEntry', date: string, id: string, timeIn: string, timeOut: string, lunchStart?: string | null, lunchEnd?: string | null, lunchHours?: string | null, hoursWorked: string, eeCode: string, lastAdminNotes?: string | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null> | null, timeOff?: Array<{ __typename?: 'TimeOffEntry', date: string, id: string, hours: string, timeOffType: Types.TimeOffType, eeCode: string, lastAdminNotes?: string | null } | null> | null, projectTime?: Array<{ __typename?: 'ProjectTimeEntry', hours: string, id: string, eeCode: string, date: string, rate?: number | null, taskName: string, notes: string, lastAdminNotes?: string | null, pdfDownloadUrl: string, myRole?: Types.CrewRole | null, otherRole1?: Types.CrewRole | null, otherRole2?: Types.CrewRole | null, crewSize: number, trainingUploadImageId?: string | null, trainingUploadImageUrl?: string | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, project?: { __typename?: 'Project', name: string, number: number, status: Types.ProjectStatus, customer?: { __typename?: 'Customer', number?: string | null } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, serviceDescription?: { __typename?: 'ServiceDescription', projectType: string } | null } | null, dailyHours?: Array<{ __typename?: 'ProjectTimeDailyHours', asBuilt: string, boundary: string, clStake: string, constRestake: string, constStake: string, employeeId: number, locate: string, rainoutOther: string, rerouteStake: string, role: Types.ProjectTimeDailyRole, travelHours: string, employee?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string } | null } | null> | null, otherCrew1?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string } | null, otherCrew2?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string } | null, employee?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string } | null } | null> | null, expenses?: Array<{ __typename: 'AdHocExpense', rate: number, quantity: number, receiptImageId?: string | null, receiptImageUrl?: string | null, eeCode: string, id: string, rateName: string, rateSheetName: string, notes?: string | null, payable: Types.Payable, date: string, invoiceLabel?: string | null, expenseAccount?: string | null, billableAmount?: number | null, payableAmount: number, lastAdminNotes?: string | null, payableOverridden: boolean, project?: { __typename?: 'Project', name: string, number: number, status: Types.ProjectStatus, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'AtvExpense', eeCode: string, id: string, rateName: string, rateSheetName: string, notes?: string | null, payable: Types.Payable, date: string, invoiceLabel?: string | null, expenseAccount?: string | null, billableAmount?: number | null, payableAmount: number, lastAdminNotes?: string | null, payableOverridden: boolean, project?: { __typename?: 'Project', name: string, number: number, status: Types.ProjectStatus, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'FuelExpense', odometer?: number | null, vehicleNumber?: string | null, quantity: number, receiptTotal: number, payerInformation: Types.PayerInformation, companyVehicle: boolean, receiptImageId?: string | null, receiptImageUrl?: string | null, eeCode: string, id: string, rateName: string, rateSheetName: string, notes?: string | null, payable: Types.Payable, date: string, invoiceLabel?: string | null, expenseAccount?: string | null, billableAmount?: number | null, payableAmount: number, lastAdminNotes?: string | null, payableOverridden: boolean, project?: { __typename?: 'Project', name: string, number: number, status: Types.ProjectStatus, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'MileageExpense', beginningOdometer: number, endingOdometer: number, vehicleNumber?: string | null, companyVehicle: boolean, mileage: number, eeCode: string, id: string, rateName: string, rateSheetName: string, notes?: string | null, payable: Types.Payable, date: string, invoiceLabel?: string | null, expenseAccount?: string | null, billableAmount?: number | null, payableAmount: number, lastAdminNotes?: string | null, payableOverridden: boolean, project?: { __typename?: 'Project', name: string, number: number, status: Types.ProjectStatus, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'MobileAllowanceExpense', eeCode: string, id: string, rateName: string, rateSheetName: string, notes?: string | null, payable: Types.Payable, date: string, invoiceLabel?: string | null, expenseAccount?: string | null, billableAmount?: number | null, payableAmount: number, lastAdminNotes?: string | null, payableOverridden: boolean, project?: { __typename?: 'Project', name: string, number: number, status: Types.ProjectStatus, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'PerDiemExpense', receiptImageId?: string | null, receiptImageUrl?: string | null, eeCode: string, id: string, rateName: string, rateSheetName: string, notes?: string | null, payable: Types.Payable, date: string, invoiceLabel?: string | null, expenseAccount?: string | null, billableAmount?: number | null, payableAmount: number, lastAdminNotes?: string | null, payableOverridden: boolean, project?: { __typename?: 'Project', name: string, number: number, status: Types.ProjectStatus, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'ReceiptValuedExpense', payerInformation: Types.PayerInformation, odometer?: number | null, vehicleNumber?: string | null, receiptTotal: number, receiptImageId?: string | null, receiptImageUrl?: string | null, eeCode: string, id: string, rateName: string, rateSheetName: string, notes?: string | null, payable: Types.Payable, date: string, invoiceLabel?: string | null, expenseAccount?: string | null, billableAmount?: number | null, payableAmount: number, lastAdminNotes?: string | null, payableOverridden: boolean, project?: { __typename?: 'Project', name: string, number: number, status: Types.ProjectStatus, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'TcpAllowanceExpense', eeCode: string, id: string, rateName: string, rateSheetName: string, notes?: string | null, payable: Types.Payable, date: string, invoiceLabel?: string | null, expenseAccount?: string | null, billableAmount?: number | null, payableAmount: number, lastAdminNotes?: string | null, payableOverridden: boolean, project?: { __typename?: 'Project', name: string, number: number, status: Types.ProjectStatus, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null> | null } | null } | null };


export const WorkDayQueryDocument = gql`
    query WorkDayQuery($date: LocalDate!, $userPrincipalName: String!) {
  timesheets {
    workDay(date: $date, userPrincipalName: $userPrincipalName) {
      date
      workDayId
      editable
      employee {
        firstName
        lastName
        email
        userPrincipalName
        timeEntryMethod
        isMobileEmployee
      }
      timeEntries {
        date
        location {
          state
          county
        }
        id
        timeIn
        timeOut
        lunchStart
        lunchEnd
        lunchHours
        hoursWorked
        eeCode
        lastAdminNotes
      }
      timeOff {
        date
        id
        hours
        timeOffType
        eeCode
        lastAdminNotes
      }
      projectTime {
        hours
        id
        eeCode
        date
        location {
          state
          county
        }
        project {
          name
          number
          customer {
            number
          }
          location {
            state
            county
          }
          serviceDescription {
            projectType
          }
          status
        }
        rate
        taskName
        notes
        lastAdminNotes
        pdfDownloadUrl
        dailyHours {
          asBuilt
          boundary
          clStake
          constRestake
          constStake
          employee {
            firstName
            lastName
            userPrincipalName
          }
          employeeId
          locate
          rainoutOther
          rerouteStake
          role
          travelHours
        }
        myRole
        otherRole1
        otherCrew1 {
          firstName
          lastName
          userPrincipalName
        }
        otherRole2
        otherCrew2 {
          firstName
          lastName
          userPrincipalName
        }
        employee {
          firstName
          lastName
          userPrincipalName
        }
        crewSize
        trainingUploadImageId
        trainingUploadImageUrl
      }
      expenses {
        eeCode
        id
        rateName
        rateSheetName
        notes
        payable
        date
        invoiceLabel
        expenseAccount
        billableAmount
        payableAmount
        lastAdminNotes
        payableOverridden
        location {
          state
          county
        }
        __typename
        ... on AtvExpense {
          project {
            name
            number
            location {
              state
              county
            }
            status
          }
        }
        ... on FuelExpense {
          odometer
          vehicleNumber
          quantity
          receiptTotal
          payerInformation
          companyVehicle
          receiptImageId
          receiptImageUrl
          project {
            name
            number
            location {
              state
              county
            }
            status
          }
        }
        ... on MileageExpense {
          beginningOdometer
          endingOdometer
          vehicleNumber
          companyVehicle
          mileage
          project {
            name
            number
            location {
              state
              county
            }
            status
          }
        }
        ... on MobileAllowanceExpense {
          project {
            name
            number
            location {
              state
              county
            }
            status
          }
        }
        ... on PerDiemExpense {
          project {
            name
            number
            location {
              state
              county
            }
            status
          }
          receiptImageId
          receiptImageUrl
        }
        ... on ReceiptValuedExpense {
          payerInformation
          odometer
          vehicleNumber
          receiptTotal
          receiptImageId
          receiptImageUrl
          project {
            name
            number
            location {
              state
              county
            }
            status
          }
        }
        ... on TcpAllowanceExpense {
          project {
            name
            number
            location {
              state
              county
            }
            status
          }
        }
        ... on AdHocExpense {
          rate
          quantity
          receiptImageId
          receiptImageUrl
          project {
            name
            number
            location {
              state
              county
            }
            status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useWorkDayQueryQuery__
 *
 * To run a query within a React component, call `useWorkDayQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkDayQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkDayQueryQuery({
 *   variables: {
 *      date: // value for 'date'
 *      userPrincipalName: // value for 'userPrincipalName'
 *   },
 * });
 */
export function useWorkDayQueryQuery(baseOptions: Apollo.QueryHookOptions<WorkDayQueryQuery, WorkDayQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkDayQueryQuery, WorkDayQueryQueryVariables>(WorkDayQueryDocument, options);
      }
export function useWorkDayQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkDayQueryQuery, WorkDayQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkDayQueryQuery, WorkDayQueryQueryVariables>(WorkDayQueryDocument, options);
        }
export type WorkDayQueryQueryHookResult = ReturnType<typeof useWorkDayQueryQuery>;
export type WorkDayQueryLazyQueryHookResult = ReturnType<typeof useWorkDayQueryLazyQuery>;
export type WorkDayQueryQueryResult = Apollo.QueryResult<WorkDayQueryQuery, WorkDayQueryQueryVariables>;